import joi from 'joi';

import { type Filters, filtersSchema } from './filters/filters';

export const TABLE_OPTIONS_QUERY_PARAMETER = 'options';

export interface TableQueryOptions {
  filters?: Filters;
}

export const tableQueryOptionsSchema = joi.object({
  filters: filtersSchema,
});
